import { render, staticRenderFns } from "./SiderRoutes.vue?vue&type=template&id=43944c01&scoped=true&"
import script from "./SiderRoutes.vue?vue&type=script&lang=js&"
export * from "./SiderRoutes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43944c01",
  null
  
)

export default component.exports